import React, { useEffect, useState } from "react";
import { Button, Card, Input, message, Switch, Modal } from "antd";
import axios from "axios";
import consts from "../../constant";
import { Form } from "antd";
import { QRCodeSVG } from "qrcode.react";
import Loadingpage from "../Loadingpage/Loadingpage";
import { CopyOutlined } from "@ant-design/icons";
// import Slider from '@mui/material/Slider'
const Settings = () => {
  let [profile, setProfile] = useState({});
  let [load, setLoad] = useState(false);
  let [formLayout, setFormLayout] = useState("vertical");
  const [messageApi, contextHolder] = message.useMessage();
  const [passwordForm] = Form.useForm();
  const [infoForm] = Form.useForm();

  // 🔑 2FA states
  let [openModal, setOpenModal] = useState(false);
  let [otpUrl, setOtpUrl] = useState("");
  let [code, setCode] = useState("");
  let [otpCode, setOtpCode] = useState("");
  let [verifying, setVerifying] = useState(false);


  const onChange = async (checked) => {
    if (checked) {
      try {
        setLoad(true);
        const response = await axios.post(
          `${consts.BackendUrl}/generateadmin2fa`,
          {},
          {
            headers: {
              Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
            },
          }
        );
        if (!response || !response.data.success) {
          setLoad(false);
          messageApi.error(response?.data?.message || "Failed to generate 2FA");
          return;
        }
        console.log(response);
        // backend must return otpauth url (e.g. otpauth://totp/....)
        setOtpUrl(response?.data?.result?.otpauth_url);
        setOtpCode(response?.data?.result?.secret);
        setOpenModal(true);
        setLoad(false);
      } catch (error) {
        setLoad(false);
        messageApi.error(error?.response?.data?.message || "Error generating 2FA");
        console.log(error);
      }
    } else {

      setOpenModal(true);
      setLoad(false);

    }
  };

  const handleVerify = async () => {
    setVerifying(true);
    try {
      if (!code || !code.trim() === "") {
        messageApi.error("Please enter code");
        return;
      }
      if (code.length < 6 || code.length > 6) {
        messageApi.error("Invalid code");
        return;
      }
      let response;
      if (profile?.f2A_Status === "true") {
        response = await axios.post(
          `${consts.BackendUrl}/disableadmin2fa`,
          { secret: code },
          {
            headers: {
              Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
            },
          },
        );
      } else {
        response = await axios.post(
          `${consts.BackendUrl}/verifyadmin2fa`,
          { email: profile?.email, secret: code, status: "verify" },
          {
            headers: {
              Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
            },
          },
        );
      }

      if (response.data.success) {
        if (profile?.f2A_Status === "true") {
          messageApi.success("Two-Factor Authentication disabled!");
        } else {
          messageApi.success("Two-Factor Authentication enabled!");
        }

        setOtpCode("");
        setCode("");
        setOtpUrl("");
        setOpenModal(false);
        getProfile();
      } else {
        messageApi.error(response.data.message || "Invalid code");
      }
    } catch (error) {
      messageApi.error(error?.response?.data?.message || "Verification failed");
      console.log(error);
    } finally {
      setVerifying(false);
    }
  };


  // qr scan copy

  const handleCopy = () => {
    navigator.clipboard.writeText(otpCode);
  };

  const getProfile = async () => {
    setLoad(true);
    try {
      const response = await axios.post(
        `${consts.BackendUrl}/getAdmin`,
        {},
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        },
      );
      if (response?.data?.success) {
        setProfile(response?.data?.result);
      } else {
        setProfile({});
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoad(false);
    }
  };

  const onFinish = async (values) => {
    console.log(values);
  };

  const onUpdateFinish = async (values) => {
    setLoad(true);

    try {
      let payload = { ...values };

      if (Object.keys(payload).includes("name")) {
        if (!payload?.name) {
          messageApi.error("Enter name");
          setLoad(false);
          return;
        }

        // Remove values that haven't changed to avoid backend rejection
        if (payload.name === profile?.name) {
          delete payload.name;
        }

        // If nothing actually changed, exit early
        if (Object.keys(payload).length === 0) {
          messageApi.error("No changes made");
          setLoad(false);
          return;
        }
      }

      if (Object.keys(payload).includes("password")) {
        if (!payload?.oldpassword) {
          messageApi.error("Please enter old password");
          setLoad(false);
          return;
        }

        if (!payload?.password) {
          messageApi.error("Please enter new password");
          setLoad(false);
          return;
        }
        if (!payload?.confirmpassword) {
          messageApi.error("Please enter confirm password");
          setLoad(false);
          return;
        }
        if (payload?.password?.length < 6) {
          messageApi.error("Password must be at least 6 characters long");
          setLoad(false);
          return;
        }
        if (payload?.password !== payload?.confirmpassword) {
          messageApi.error("Passwords do not match");
          setLoad(false);
          return;
        }
      }

      const response = await axios.post(
        `${consts.BackendUrl}/updateAdmin`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        },
      );
      if (!response || !response?.data?.success) {
        setLoad(false);
        messageApi.error(response?.data?.message || "Update failed");
        return;
      }
      if (Object.keys(values).includes("password")) {
        messageApi.success("Password updated successfully");
        passwordForm.resetFields();
        return;
      }
      messageApi.success("Profile Updated successfully");
      getProfile();
      infoForm.resetFields();
    } catch (error) {
      console.log(error);
      messageApi.error(
        error?.response?.data?.message || "Error updating profile",
      );
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [form] = Form.useForm();

  const showModal = () => {
    form.setFieldsValue({
      name: profile?.name,
    });
    setIsModalOpen(true);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        console.log("Form Values:", values);
        await onUpdateFinish(values);
        setIsModalOpen(false);
        form.resetFields();
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Loadingpage />
      <div>
        <h2>Settings</h2>
        <div className="display-3  mb-10 gap-10">
          <Card className="card-bg-clr" style={{ width: "100%", height: 390 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <h3>ABOUT ME</h3>
                <p>Name : {profile.name && profile.name}</p>
                {/* <p>User name : {"User name"}</p> */}
                <p>Email : {profile.email && profile.email} </p>
                <div className="display-1 ">
                  <Switch
                    checked={profile.f2A_Status === "true"}
                    onChange={onChange}
                  />
                  <span>
                    Two Factor Authenticator{" "}
                    <b>
                      {profile.f2A_Status === "true" ? "Enabled" : "Disabled"}
                    </b>
                  </span>
                </div>
              </div>

              <Button
                type="primary"
                htmlType="submit"
                onClick={showModal}
              //  disabled={profile.role === "admin" ? true : profile.role === "subadmin" ? false : true}
              >
                Edit
              </Button>
            </div>
          </Card>

          {/* Modal for QR + Code input */}
          <Modal
            title="Enable Two Factor Authentication"
            open={openModal}
            centered
            width={window.innerWidth < 480 ? "90%" : 400}
            onCancel={() => {
              setOpenModal(false);
              setCode("");
            }}
            footer={null}
            maskClosable={false}
            maskStyle={{
              backdropFilter: "blur(8px)",
              backgroundColor: "rgba(0, 0, 0, 0.2)",
            }}
            styles={{
              content: {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                color: "white",
              },
              header: {
                backgroundColor: "transparent",
              },
            }}
          >
            <p style={{ color: "white" }}>
              Scan this QR code in Authenticator:
            </p>
            {otpUrl && (
              <div style={{ textAlign: "center", marginBottom: 16 }}>
                <QRCodeSVG
                  value={otpUrl}
                  size={170}
                  style={{ border: "1px solid ", backgroundColor: "white", padding: "10px" }}
                />

                <span>
                  {otpCode}
                  <CopyOutlined
                    onClick={handleCopy}
                    style={{ cursor: "pointer", marginLeft: 5 }}
                  />
                </span>
              </div>
            )}
            <Input
              placeholder="Enter 6-digit code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              maxLength={6}
              style={{ marginBottom: 12 }}
            />
            <Button
              block
              // style={{ backgroundColor: "", color: "#ff" }}
              loading={verifying}
              onClick={handleVerify}
            >
              Verify & Enable
            </Button>
          </Modal>
          {/* edit model */}

          <div className="center-box">
            <Modal
              title="Edit Name"
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              centered
              width={window.innerWidth < 480 ? "90%" : 400} //  responsive width
              maskClosable={false}
              maskStyle={{
                backdropFilter: "blur(8px)",
                backgroundColor: "rgba(0, 0, 0, 0.2)",
              }}
              styles={{
                content: {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  color: "white",
                },
                header: {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Form form={form} layout="vertical">
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    { required: true, message: "Please enter your name" },
                  ]}
                >
                  <Input placeholder="Enter name" />
                </Form.Item>
              </Form>
            </Modal>
          </div>

          <Card className="card-bg-clr" style={{ width: "100%", height: 390 }}>
            <h3>Change Password</h3>
            <Form
              layout={formLayout}
              form={passwordForm}
              onFinish={onUpdateFinish}
              style={{ maxWidth: formLayout === "inline" ? "none" : 600 }}
            >
              <Form.Item
                label="Old Password"
                name="oldpassword"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject(
                          new Error("Please enter old password"),
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="Old Password" />
              </Form.Item>

              <Form.Item
                label="New Password"
                name="password"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject(
                          new Error("Please enter new password"),
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="New Password" />
              </Form.Item>

              <Form.Item
                label="Confirm Password"
                name="confirmpassword"
                dependencies={["password"]}
                required
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject(
                          new Error("Please enter confirm password"),
                        );
                      }
                      if (getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      if (value && value !== getFieldValue("password")) {
                        return Promise.reject(
                          new Error("Passwords do not match!"),
                        );
                      } else {
                        return Promise.reject(
                          new Error("Please enter confirm password"),
                        );
                      }
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="Confirm Password" />
              </Form.Item>

              <Button
                type="primary"
                htmlType="submit"
              //  disabled={profile.role === "admin" ? true : profile.role === "subadmin" ? false : true}
              >
                Save
              </Button>
            </Form>
          </Card>
        </div>

        {contextHolder}
      </div>
    </>
  );
};

export default Settings;
